var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "deviceCheck" },
    [
      _c(
        "el-steps",
        { attrs: { active: _vm.stepsActive, "align-center": "" } },
        [
          _c("el-step", {
            attrs: {
              title: "浏览器检测",
              description: "检查当前浏览器是否兼容",
            },
          }),
          _vm._v(" "),
          _c("el-step", {
            attrs: {
              title: "摄像头检测",
              description: "检查当前电脑摄像头是否可用",
            },
          }),
          _vm._v(" "),
          _c("el-step", {
            attrs: {
              title: "麦克风检测",
              description: "检查当前电脑麦克风是否可用",
            },
          }),
          _vm._v(" "),
          _c("el-step", {
            attrs: {
              title: "扬声器检测",
              description: "检查当前电脑扬声器是否可用",
            },
          }),
          _vm._v(" "),
          _vm.type == "teacher"
            ? _c("el-step", {
                attrs: {
                  title: "屏幕分享",
                  description: "用于上课视频录制以及图片截取",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.stepsActive == 0
        ? _c("div", [
            _c(
              "div",
              { class: _vm.step1PassStatus ? "step1Box pass" : "step1Box" },
              [
                _c("span", { class: _vm.step1PassStatus ? "pass" : "" }, [
                  _vm._v(_vm._s(_vm.step1)),
                ]),
                _vm._v(" "),
                !_vm.step1PassStatus
                  ? _c("span", { staticClass: "userAgentBox" }, [
                      _vm._v(_vm._s(_vm.userAgent)),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btnBox" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", round: "" },
                    on: {
                      click: function ($event) {
                        _vm.stepsActive++
                      },
                    },
                  },
                  [_vm._v("下一步")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.stepsActive == 1,
              expression: "stepsActive == 1",
            },
          ],
        },
        [
          _c("div", { staticClass: "step2Box" }, [
            _vm.attentionShow == 2
              ? _c("span", { staticClass: "attention" }, [
                  _vm._v(
                    "注意：暂时无法访问摄像头，请确保当前没有其他应用请求访问摄像头，并重试。"
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "stream", attrs: { id: "stream" } }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "step2Content" },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "请选择" },
                    on: { change: _vm.changeVideo },
                    model: {
                      value: _vm.cameasActive,
                      callback: function ($$v) {
                        _vm.cameasActive = $$v
                      },
                      expression: "cameasActive",
                    },
                  },
                  _vm._l(_vm.cameras, function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.label, value: item.deviceId },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.attentionShow == 1
            ? _c(
                "div",
                { staticClass: "btnBox" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", round: "" },
                      on: {
                        click: function ($event) {
                          _vm.stepsActive++
                        },
                      },
                    },
                    [_vm._v("下一步")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.stepsActive == 2
        ? _c("div", [
            _c("div", { staticClass: "step3Box" }, [
              _vm.attentionShow == 2
                ? _c("span", { staticClass: "attention" }, [
                    _vm._v(
                      "注意：暂时无法访问麦克风，请确保当前没有其他应用请求访问麦克风，并重试。"
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "microphonesBox" }, [
                _c(
                  "div",
                  { staticClass: "volumebar" },
                  [
                    _c("span", [_vm._v("输出")]),
                    _vm._v(" "),
                    _c("el-progress", {
                      attrs: {
                        percentage: _vm.percentageNum,
                        "show-text": false,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "step3Content" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.changeAudio },
                      model: {
                        value: _vm.microphonesActive,
                        callback: function ($$v) {
                          _vm.microphonesActive = $$v
                        },
                        expression: "microphonesActive",
                      },
                    },
                    _vm._l(_vm.microphones, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.deviceId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.attentionShow == 1
              ? _c(
                  "div",
                  { staticClass: "btnBox" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", round: "" },
                        on: {
                          click: function ($event) {
                            _vm.stepsActive++
                          },
                        },
                      },
                      [_vm._v("下一步")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.stepsActive == 3
        ? _c("div", [
            _c(
              "div",
              { staticClass: "step4Box" },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "请选择" },
                    on: { change: _vm.changeloudspeaker },
                    model: {
                      value: _vm.loudspeakerActive,
                      callback: function ($$v) {
                        _vm.loudspeakerActive = $$v
                      },
                      expression: "loudspeakerActive",
                    },
                  },
                  _vm._l(_vm.loudspeakers, function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.label, value: item.deviceId },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _vm.loudspeakerStatus
                  ? _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.handlerDeviceAudio("stop")
                          },
                        },
                      },
                      [_vm._v("停止检测")]
                    )
                  : _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.handlerDeviceAudio("play")
                          },
                        },
                      },
                      [_vm._v("检测扬声器")]
                    ),
                _vm._v(" "),
                _c("audio", {
                  ref: "deviceAudio",
                  attrs: { src: require("@/assets/audio/device_check.mp3") },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btnBox" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", round: "" },
                    on: { click: _vm.stopDeviceAudio },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.type == "teacher" ? "下一步" : "进入教室")
                    ),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.stepsActive == 4
        ? _c("div", [
            _c("div", { staticClass: "step5Box" }, [
              _vm._v(
                "\n            设备检测通过之后每一次上课进入教室时都会弹出屏幕分享弹窗，用于上课视频录制以及图片截取\n        "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btnBox" },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$emit("changeLiveCheck")
                      },
                    },
                  },
                  [_vm._v("进入教室")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/deviceCheck.vue?vue&type=template&id=4aa197c0&scoped=true&
// module id = null
// module chunks = 